::ng-deep app-root .public-container{display:flex;width:100%;height:100%;background:#fff}
/*# sourceMappingURL=bootstrap.component-SFWVEYNP.css.map */
